import { GoDotFill } from 'react-icons/go'

export function NavigationDots({ totalSlides, currentSlide }) {
	return <div className='tw-space-x-3'>{[...Array(totalSlides)].map((_, index) => (index + 1 === currentSlide ? <GoDotFill key={index} size={20} className='tw-opacity-100' /> : <GoDotFill key={index} size={20} className='tw-opacity-30' />))}</div>
}
